import { Fragment, ReactNode } from 'react';
import { Badge, Box, Popover, Stack } from '@ff-it/ui';
import { listItem, more, moreContainer } from './TruncatedList.css';

interface TruncatedListProps<T> {
  items: T[];
  limit?: number;
  renderItem: (item: T, index: number) => ReactNode;
  getKey: (item: T) => string | number;
  moreLabel?: (count: number) => string;
}

export function TruncatedList<T>({ items, limit = 5, renderItem, getKey }: TruncatedListProps<T>): ReactNode {
  const visibleItems = items.slice(0, limit);
  const remainingItems = items.slice(limit);

  return (
    <Stack direction="horizontal" align="center">
      {visibleItems.map((item, index) => (
        <Box key={getKey(item)} className={listItem}>
          {renderItem(item, index)}
        </Box>
      ))}
      {remainingItems.length > 0 && (
        <Popover
          interaction="hover"
          content={
            <Stack direction="vertical" p="3" className={moreContainer}>
              {remainingItems.map((item, index) => (
                <Fragment key={getKey(item)}>{renderItem(item, limit + index)}</Fragment>
              ))}
            </Stack>
          }
        >
          <Box cursor="pointer" className={more}>
            <Badge count={`+${remainingItems.length}`} />
          </Box>
        </Popover>
      )}
    </Stack>
  );
}
